import { createAction } from 'typesafe-actions'

export const runGuidedTour = createAction('@@guidedTour/run')<boolean>()
export const intentOpenGuidedTour = createAction('@@guidedTour/intentOpenGuidedTour')()
export const openLoadingDialog = createAction('@@guidedTour/openLoadingDialog')()
